export enum ProductCategory {
    ALL = 'ALL',
    Software = 'Software',
    database = 'Datenbanken',
    SpecPub = 'Fachpublikationen'
}
